export interface DocPaginatorState {
  page?: number;
  first?: number;
  rows?: number;
  pageCount?: number;
}

export function buildDocPaginatorState(
  first: number,
  rows: number,
  totalRecords: number
): DocPaginatorState {
  const safeRows = Math.max(1, rows);
  const page = Math.floor(first / safeRows);
  const pageCount = Math.max(1, Math.ceil(totalRecords / safeRows));

  return {
    first,
    rows: safeRows,
    page,
    pageCount,
  };
}

export function formatDocPaginatorReport(
  template: string,
  first: number,
  rows: number,
  totalRecords: number
): string {
  const displayFirst = totalRecords === 0 ? 0 : first + 1;
  const displayLast = totalRecords === 0 ? 0 : Math.min(first + rows, totalRecords);

  return template
    .replace(/\{first\}/g, String(displayFirst))
    .replace(/\{last\}/g, String(displayLast))
    .replace(/\{totalRecords\}/g, String(totalRecords))
    .replace(/\{rows\}/g, String(rows));
}
